

import React from 'react';
import { FormDynamic } from "../../core/resources/FormDynamic";
import { Action, Fab } from 'react-tiny-fab';
import { outerTheme } from '../../App';


interface PropsSocialButtons {
    form: FormDynamic
  }
  
  const hendleGoToPage = (path:string="")=>{
    window.open(path,'_blank');
  }
  export const SocialButtons: React.FC<PropsSocialButtons> = (props) => {
      const {form } = props;
    if(form.social.fb == null && form.social.instagram == null && form.pageweb == null)
     return null

      return <>
                    <Fab
                    style={{bottom: 10, right: 10, margin:"0px"}}
                    mainButtonStyles={{ backgroundColor: outerTheme.palette.primary.dark, width:"45px",height:"45px"}}
                    icon={ <img src="./assets/images/info.svg" width="25px"  alt="" />}
                    alwaysShowTitle={true}
                            >
            {
            form.social.fb ? 
                    <Action
                    style={{background:"#fff"}}
                    text="Facebook"
                    onClick={() => hendleGoToPage(form.social.fb)}
                >
                    <img src="./assets/images/facebook.svg" width="25px" alt=""/>
                    </Action>
                     : null
            }
             {
            form.social.instagram ? 
                    <Action
                    style={{background:"#fff"}}
                    text="Instagram"
                    onClick={() => hendleGoToPage(form.social.instagram)}
                >
                    <img src="./assets/images/instagram.svg" width="25px" alt="" />
                    </Action>
                     : null
            }
            {
            form.pageweb ? 
                    <Action
                    style={{background:"#fff"}}
                    text="Sito Web"
                    onClick={() => hendleGoToPage(form.pageweb)}
                >
                    <img src="./assets/images/internet.svg" width="25px"  alt=""/>
                    </Action>
                     : null
            }
            
        
            </Fab>
        </> 
  

}
